import { ThemeSettings } from "./theme-settings";

export default function ThemePage() {
  return <ThemeSettings />;
}
